function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 33.9653,
  cy: 4.96534,
  r: 4.96534,
  fill: "#6AAA9B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29 16.4238C29 13.6816 31.2231 11.4585 33.9653 11.4585C36.7076 11.4585 38.9307 13.6816 38.9307 16.4238V24.4448H29V16.4238Z",
  fill: "#6AAA9B"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.48636,
  cy: 49.4864,
  r: 2.95,
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.536364 57.5318C0.536364 55.9025 1.85712 54.5818 3.48636 54.5818C5.1156 54.5818 6.43636 55.9025 6.43636 57.5318V62.6272H0.536364V57.5318Z",
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.4864,
  cy: 49.4864,
  r: 2.95,
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5364 57.5318C20.5364 55.9025 21.8571 54.5818 23.4864 54.5818C25.1156 54.5818 26.4364 55.9025 26.4364 57.5318V62.6272H20.5364V57.5318Z",
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.4864,
  cy: 49.4864,
  r: 2.95,
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5364 57.5318C40.5364 55.9025 41.8571 54.5818 43.4864 54.5818C45.1156 54.5818 46.4364 55.9025 46.4364 57.5318V62.6272H40.5364V57.5318Z",
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 63.4864,
  cy: 49.4864,
  r: 2.95,
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5364 57.5318C60.5364 55.9025 61.8571 54.5818 63.4864 54.5818C65.1156 54.5818 66.4364 55.9025 66.4364 57.5318V62.6272H60.5364V57.5318Z",
  stroke: "#9DBFCE",
  strokeWidth: 1.07273
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6626 28L4.5 41",
  stroke: "#EADFA9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M34 28L63.1626 41",
  stroke: "#EADFA9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M33.2794 28.606L42.9999 41",
  stroke: "#EADFA9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7205 28.606L24 41",
  stroke: "#EADFA9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGroupe = function SvgGroupe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroupe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/groupe.01218326.svg";
export { ForwardRef as ReactComponent };